import { render, staticRenderFns } from "./AddeditEvaluate.vue?vue&type=template&id=af4cbe0a&scoped=true&"
import script from "./AddeditEvaluate.vue?vue&type=script&lang=js&"
export * from "./AddeditEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./AddeditEvaluate.vue?vue&type=style&index=0&id=af4cbe0a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4cbe0a",
  null
  
)

export default component.exports